import { FormControl } from '@angular/forms'
import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-input-error',
    templateUrl: './input-error.component.html',
    styleUrls: ['./input-error.component.scss'],
})
export class InputErrorComponent {
    @Input() control: any
    constructor() {}

    get errorMessage() {
        if (!this.control.errors) return null

        if (this.control.errors?.message) return this.control.errors.message

        if (this.control.errors?.required) return 'This field is required'

        return 'Esse campo é inválido'
    }
}
